export const bodyPage = () => {
  const pageBody = document.getElementById('body-page');
  return pageBody;
};
